import React from "react";
import arrow from "../../assets/kangaroo/arrow-cropped.svg";
import { Col, Container, Row } from "reactstrap";

const MainComponent = () => {
  return (
    <>
      <Container fluid>
        <Row >
          <Col> 
          
          <Row>
            <Col lg={12}>
              <h5 className="maincomponent-font lh-1 mb-4 ">
                START SMART
                <br />
                <span className="font-level-3 fw-normal ">with</span> KANGAROO
              </h5>
            </Col>
          </Row>
          </Col>

          <Row>
            {/* TEXT */}
            <Col lg={8}>
              <div className="position-relative">
                <p className="font-level-2">
                  Interact with each letter of KANGAROO to discover how we can
                  help you begin your study abroad journey.
                </p>

                {/* <img
                  src={arrow}
                  className="img-fluid object-fit-contain"
                  style={{
                    position: "absolute",
                    top: 9,
                    right: -75,
                  }}
                /> */}

                <img
                  src={arrow}
                  className="img-fluid object-fit-contain position-absolute d-none d-lg-block"
                  style={{ top: 9, right: -75 }}
                />

                <img
                  src={arrow}
                  className="img-fluid object-fit-contain d-block d-lg-none mt-2 mx-auto rotate-90"
                />
              </div>
            </Col>
          </Row>
        </Row>
      </Container>
    </>
  );
};

export default MainComponent;
